import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CustomerNotificationModel } from '../../../../business-entities/customer-communication';
import { CampaignStepType } from 'projects/Administration/src/app/business-entities/campaign-list-model';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { CultureLocaleService } from 'projects/Administration/src/app/services/culture-locale.service';
import { DealerDataService } from 'projects/Administration/src/app/data-services/dealer-data.service';
import { ManualNotificationRecipientList, ManualNotificationRequestModel, ManualTemplateDetailModel } from 'projects/Administration/src/app/business-entities/manual-notification-model';
import Quill from 'quill';
import { CountryISO } from 'ngx-intl-tel-input-gg';
import { SettingService } from 'projects/Administration/src/app/business-services/setting.service';
import { LanguageService } from 'projects/Administration/src/app/business-services/language.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { CookieService } from 'ngx-cookie-service';
import { ModuleModel } from 'projects/Administration/src/app/business-entities/module-model';
import { TemplateScope } from 'projects/Autofacets-Core/src/app/utils/enums';
@Component({
  selector: 'app-customer-send-notification',
  templateUrl: './customer-send-notification.component.html',
  styleUrls: ['./customer-send-notification.component.css']
})

export class CustomerSendNotificationComponent implements OnInit, OnDestroy {
  //#region Declaration
  @Input() customerDetails: any;
  selectedTemplateId: number | null = null;
  notificationModel: CustomerNotificationModel = {
    CustomerMobileCode: '',
    CustomerMobileNo: '',
    CustomerEmail: '',
    Subject: '',
    Body: '',
    ChannelType: 1,
    templateId: 0,
    templateTypeId: 0,
  };
  lstChannelType: { id: number, label: string }[] = [
    { id: 1, label: 'lblEmail' },
    { id: 2, label: 'lblSms' },
    //{ id: 3, label: 'lblPushNotification' }
  ];
  channel = CampaignStepType;
  moduleList: ModuleModel[];
  isSaveEnable: boolean = false;
  quill: Quill;
  options = {
    toolbar: {
      container: [
        [{'undo':'Undo'}, {'redo': 'Redo'}],
        [{'direction': 'rtl'}, 'blockquote'],
        [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }, { 'header': 4 }],
        ['bold', 'italic', 'strike'],
        [{'script': 'super'}, {'script': 'sub'}],
        ['link'],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        ['clean']
      ],
      handlers: {
        redo() {
          this.quill.history.redo();
        },
        undo() {
          this.quill.history.undo();
        }
      }
    },
    history: {delay: 500, maxStack: 500, userOnly: true}
  };
  CountryISO = CountryISO;
  isInitialLoad: boolean= true;
  onlyCountries: string[] = [];
  countryDialCodes: any[]= [];
  selectedCountryISO= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  templateList: ManualTemplateDetailModel[];
    templateListFiltered: ManualTemplateDetailModel[];
    languageList: any = [];
    selectedLanguage: string;
  //#endregion1

  //#region Constructor & Init
  constructor(private spinner: NgxSpinnerService,
    private readonly activeModal: NgbActiveModal,
    private readonly toaster: ToastrService,
    private readonly translate: TranslateService,
    private readonly dealerDataService: DealerDataService,
    private readonly cultureLocaleService: CultureLocaleService,
    private readonly settingService: SettingService,
    private languageService: LanguageService,
    private cookieservice: CookieService,
    private currentLanguageService: CurrentLanguage
  ) { }

  ngOnInit(): void {
        this.currentLanguageService.currentLanguage.subscribe((res) => {
      this.selectedLanguage = res;
    })
    this.onlyCountries = this.settingService.onlyCountries;
    this.countryDialCodes = this.settingService.countryDialCodes;
    this.GetNotificationData();
    this.getManualNotificationData();
    this.getLangugage();
  }
  ngOnDestroy(): void {
    this.resetControls();
  }
  //#endregion

  //#region Page Method
  resetControls() {
    this.notificationModel = {
      CustomerMobileCode: '',
      CustomerMobileNo: '',
      CustomerEmail: '',
      Subject: '',
      Body: '',
      ChannelType: 1,
      templateTypeId: 0,
      templateId: 0
    };
    this.ValidateFields();
  }
  ValidateFields(clearData: boolean = false) {
    if (!this.notificationModel.ChannelType) {
      this.isSaveEnable = false;
    }
    else if (this.notificationModel.ChannelType == this.channel.SMS &&
      (!this.notificationModel.Body || !this.notificationModel.CustomerMobileNo
        || !this.notificationModel.CustomerMobileCode)) {
      this.isSaveEnable = false;
    }
    else if (this.notificationModel.ChannelType != this.channel.SMS &&
      (!this.notificationModel.Body || !this.notificationModel.Subject
        || !this.notificationModel.CustomerEmail)) {
      this.isSaveEnable = false;
    }
    // else if (this.notificationModel.ChannelType != this.channel.PushNotification &&
    //   (!this.notificationModel.Body || !this.notificationModel.Subject)) {
    //   this.isSaveEnable = false;
    // }
    else {
      this.isSaveEnable = true;
    }
    if(clearData){
      this.selectedTemplateId = null;
      this.notificationModel.Body = "";
      this.notificationModel.Subject = "";      
    }
    this.templateListFiltered = this.templateList.filter(x => x.templateType == this.notificationModel.ChannelType);
  }
  onChannelChange(type: number) {
    this.notificationModel.ChannelType = type;
    this.ValidateFields(true); 

  }
  OnClose() {
    this.activeModal.close();
  }
  GetNotificationData() {
    if(this.customerDetails){
      this.notificationModel = {
        CustomerMobileCode: this.customerDetails.mobileCode,
        CustomerMobileNo: this.customerDetails.mobileNo,
        CustomerEmail: this.customerDetails.email,
        Subject: '',
        Body: '',
        ChannelType: 1,
        templateTypeId: 0,
        templateId: 0
      };
    }
  }
  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }
  onCountryChange(obj3) {
    if (this.isInitialLoad) {
    this.telInputObject();
    this.notificationModel.CustomerMobileCode = this.notificationModel.CustomerMobileCode || obj3.dialCode;
    this.isInitialLoad = false;
    } else {
      this.notificationModel.CustomerMobileCode = obj3.dialCode;
    }
  }
  telInputObject() {
    let mobileCode = this.notificationModel.CustomerMobileCode;
    if (mobileCode) {
      mobileCode = mobileCode.replace(/[+]/g, '');
      this.notificationModel.CustomerMobileCode = mobileCode;
      let countryCode = this.getCountryCodeByDialCode(mobileCode);
      this.selectedCountryISO= countryCode ? countryCode : this.cultureLocaleService.getLocale();
    }
    else {
      this.selectedCountryISO= this.cultureLocaleService.getLocale();
    }
  }

  getCountryCodeByDialCode(dialCode: any) {
    const country = this.countryDialCodes.find(c => c.dialCode === dialCode);
    return country ? country.countryCode : null;
  }
  //#endregion

  //#region API Method
  async SendNotification() {
    let sendNotificationModel: ManualNotificationRequestModel = {
      body: this.notificationModel.Body,
      subject: this.notificationModel.Subject,
      templateCode: 0,
      templateType: this.notificationModel.ChannelType,
      actionCode: 0,
      dealerId: '',
      languageCode: '',
      appointmentId: 0,
      archiveAppointmentId: 0,
      appointmentGuid: '',
      applicationId: 0,
      cultureCode: '',
      customerId: this.customerDetails.id,
      isAddNotification: false,
      loginUserId: '',
      roleId:0,
      mechanicId: 0,
      isBasic: true,
      workOrderNo:'',
      recipientList: []
    }
    let recipient: ManualNotificationRecipientList = {
      fromEmail: '',
      toEmail: this.notificationModel.CustomerEmail,
      fromMobileCode: '',
      userId:'',
      deviceId:'',
      fromMobileNo: '',
      toMobileCode: this.notificationModel.CustomerMobileNo?.dialCode ? this.notificationModel.CustomerMobileNo.dialCode.replace(/[+]/g, '') : this.notificationModel.CustomerMobileCode,
      toMobileNo: this.notificationModel.CustomerMobileNo?.number ? this.notificationModel.CustomerMobileNo.number.toString().replace(/\s+/g, '') : this.notificationModel.CustomerMobileNo
    }
    sendNotificationModel.recipientList.push(recipient);

    this.spinner.show();
    this.dealerDataService.SendNotification(sendNotificationModel).then((res) => {
      if (res.responseObject === true) {
        let msg = this.translate.instant("lblNotificationSend");
        this.toaster.success(msg);
        this.activeModal.close({ success: true });
      }
      else {
        let msg = this.translate.instant("lblNotificationSendFailedMsg");
        this.toaster.error(msg);
      }
    }).finally(() => {
      this.spinner.hide()
    });
  }

    async getLangugage() {
    await this.languageService.getAllLanguage().then(result => {
      this.languageList = result;
    });
    this.selectedLanguage = this.cookieservice.get('userSelectedLanguage').length > 0 ? this.cookieservice.get('userSelectedLanguage') : this.selectedLanguage;
  }

    getFlagImage(flag: string) {
    let uri = "assets/images/countryflags/"
    if (flag != undefined)
      return uri + flag;
  }
  async getManualNotificationData() {
    this.spinner.show();
    this.templateList = [];
    this.templateListFiltered = [];
    const requestModel = {
      IsForApprovalOrRejection: 0,
      LanguageCode: this.selectedLanguage,
      TemplateScope: TemplateScope.Customer,
    }
    await this.dealerDataService.getManualNotificationData(requestModel).then(result => {
      if (result?.responseObject) {
          this.templateList = result.responseObject.templateList;
          this.moduleList = result.responseObject.moduleList;
          if (this.lstChannelType && this.lstChannelType.length > 0) {
            this.templateListFiltered = this.templateList.filter(x=> x.templateType == this.notificationModel.ChannelType);
          }
          if (this.templateListFiltered && this.templateListFiltered.length > 0) {
            let item = this.templateListFiltered[0];
          }
        this.ValidateFields();
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide()
      }).finally(() => {
        this.spinner.hide();
      });
  }

  onLanguageChange()
  {
    this.notificationModel.Body = "";
    this.notificationModel.Subject = "";
    this.selectedTemplateId = null;
    this.getManualNotificationData();
  }
  
  onTemplateChange(templateId: number) {
    if (templateId && templateId != -1) {
      let item = this.templateList.find(x => x.id == templateId);
      if (item) {
        this.notificationModel.Body = item.body;
        this.notificationModel.Subject = item.subject;
      }
      else {
        this.notificationModel.Body = "";
        this.notificationModel.Subject = "";
      }
    }
    else {
      this.notificationModel.Body = "";
      this.notificationModel.Subject = "";
    }
    this.ValidateFields();
  }
  onTemplateClear(){
    this.selectedTemplateId = null;
    this.notificationModel.Body = "";
    this.notificationModel.Subject = "";
  }

  getSectionName(templateId){
    return this.moduleList?.find(x=>x.id == templateId)?.name ?? "";
  }
  //#endregion
}
